export default "__VITE_ASSET__10Cglp_v__"